import { render, staticRenderFns } from "./partyList.vue?vue&type=template&id=6c589794"
import script from "./partyList.vue?vue&type=script&lang=js"
export * from "./partyList.vue?vue&type=script&lang=js"
import style0 from "./partyList.vue?vue&type=style&index=0&id=6c589794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports